import React from "react";
import { createStackNavigator } from "@react-navigation/stack";

//import ListingSelectSeedOrPubtionScreen from "../screens/ListingSelectSeedOrPubtionScreen";
import ListingEditScreen from "../screens/ListingEditScreen";
import AddSeedScreen from "../screens/AddSeedScreen";
import ActionScreen from "../screens/ActionScreen";
//import ListingDetailsActionScreen from "../screens/ListingDetailsActionScreen";
import ListingDetailsSeedScreen from "../screens/ListingDetailsSeedScreen";
//import ClipboardText from "../components/ClipboardText";
import UserFixoScreen from "../screens/UserFixoScreen";
import PickerActionsScreen from "../screens/PickerActionsScreen";
import NotificationsScreen from "../screens/NotificationsScreen";
import NotificationTypeScreen from "../screens/NotificationTypeScreen";
import CommentsSeedScreen from "../screens/CommentsSeedScreen";
import ImageVisor from "../components/ImageVisor";
import ViewImageScreen from "../screens/ViewImageScreen";

const Stack = createStackNavigator();

const NotificationNavigator = () => (
  <Stack.Navigator initialRouteName="Select" >
    <Stack.Screen name="Notifications" component={NotificationsScreen} options={{ headerShown: false}} />
    <Stack.Screen name="AddPublication" component={ListingEditScreen} />
    <Stack.Screen name="AddSeed" component={AddSeedScreen} />
    <Stack.Screen name="Notifications " component={NotificationTypeScreen} />
    <Stack.Screen name="Comments Seeds" component={CommentsSeedScreen} />
    <Stack.Screen name="Imagen" component={ImageVisor} />
    <Stack.Screen name="ViewImage" component={ViewImageScreen} options={{ tabBarVisible: false, headerShown: false}} />


    <Stack.Screen name="Seed Details" component={ListingDetailsSeedScreen} options={{ tabBarVisible: false}} />
    <Stack.Screen name="Action List" component={PickerActionsScreen} />
    <Stack.Screen name="AddAction" component={ActionScreen} />

    <Stack.Screen name="User Fixo" component={UserFixoScreen} options={{ headerShown: false}} />

    



  </Stack.Navigator>
);

export default NotificationNavigator;
